// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__1bZZL","header":"MessagesList_header__1fJCr","chat":"MessagesList_chat__1FEXJ"};